
export default {
  name: "cal-moment-section",
  props: ["heading", "paragraph", "slides", "slider"],
  computed: {
    isMobile() {
      return window.matchMedia("(max-width: 768px)").matches;
    },
  },
  data() {
    return {
      NUM_OF_SLIDES_DESKTOP: 4,
      NUM_OF_SLIDES_MOBILE: 3,
      numberOfSlides: 10,
    };
  },
  methods: {
    getNumOfSlides() {
      return;
    },
  },
  created() {
    this.numberOfSlides = this.isMobile
      ? this.numOfSlidesMobile
      : this.numOfSlidesDesktop;
  },
};
